import { render, staticRenderFns } from "./ImportedActivity.vue?vue&type=template&id=547f0204&scoped=true&"
import script from "./ImportedActivity.vue?vue&type=script&lang=ts&"
export * from "./ImportedActivity.vue?vue&type=script&lang=ts&"
import style0 from "./ImportedActivity.vue?vue&type=style&index=0&id=547f0204&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "547f0204",
  null
  
)

export default component.exports